import styled from 'styled-components';

const FormFieldGroup = styled.div`
  padding: 5px 15px 15px;
`;

FormFieldGroup.displayName = 'FormFieldGroup';

export default FormFieldGroup;
